import React from 'react';
import type {StackProps} from '@tempo/core';
import {VStack} from '@tempo/core';

const FormSectionContainer: React.FC<StackProps> = ({children, ...props}) => {
	return (
		<VStack spacing="spacing.l" alignItems="initial" {...props}>
			{children}
		</VStack>
	);
};

export default FormSectionContainer;
